export default {
  text: '',
  button: ({ isRelevantSorted }) =>
    isRelevantSorted ? 'See all results' : 'See relevant results',
};
